import { Generality } from 'shell/models/person/generality';
import { SubjectAttributes } from 'shell/models/person/subject-attributes';
import { AccordionGeneralityForm } from 'shell/view-models/accordion-generality-form';
import { Document } from 'shell/models/person/document';
//import { BirthdayDocument } from 'shell/view-models/birthday-document';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import { transformCitizen } from 'shell/utils/consult-person/request-transformer/citizenship-shared';
import { Citizenship } from 'shell/models/person/citizenship';
import { PraticaVoVM } from './transform-pratica-VO';
import { Municipality, Place } from 'shell/models/person/shared';
import { Residence } from 'shell/models/person/residence';
import { DataDeletion } from 'shell/models/person/deletion-data';
import { Parenthood } from 'shell/models/person/parenthood';
import { Marriage } from 'shell/models/person/marriage';
import { CivilUnion } from 'shell/models/person/civil-union';
import { VoidMarriage } from 'shell/models/person/void-marriage';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';
import { PracticeDraftBEStep } from 'practice/constants/practice-management-step';
// import { CitizenshipVM } from 'shell/view-models/citizenship';
// import { Citizenship } from 'shell/models/person/citizenship';
// import { transformCitizen } from 'shell/utils/consult-person/request-transformer/citizenship-shared';

export const transformGenerality = (
  generality: AccordionGeneralityForm | undefined,
  isWithoutChoiceDate?: boolean
): Generality | undefined => {
  return generality
    ? {
        annoEspatrio:
          generality.aire !== 'N' ? generality?.expatriationYear || undefined : undefined,
        nome: generality?.name || undefined,
        codiceFiscale: generality.fiscalCode
          ? {
              codFiscale: generality.fiscalCode || undefined,
              validitaCF: generality.validityFiscalCodeId || undefined,
              dataAttribuzioneValidita:
                generality.validityDateFiscalCode?.toFormat('yyyy-MM-dd') || undefined,
            }
          : undefined,
        cognome: generality.surname || undefined,
        senzaCognome: generality.withoutSurname ? '1' : undefined,
        senzaNome: generality.withoutName ? '1' : undefined,
        sesso: generality.gender || 'N',
        dataNascita: generality.birthDate?.toFormat('yyyy-MM-dd') || undefined,
        senzaGiorno:
          generality?.birthDate &&
          !generality?.birthChoiceDate?.includes('day') &&
          generality?.birthChoiceDate?.includes('month')
            ? '1'
            : undefined,
        senzaGiornoMese:
          generality?.birthDate &&
          !generality?.birthChoiceDate?.includes('day') &&
          !generality?.birthChoiceDate?.includes('month') &&
          !isWithoutChoiceDate
            ? '1'
            : undefined,
        luogoNascita: {
          luogoEccezionale: generality.exceptionalBirthPlace || undefined,
          comune:
            generality.italian?.municipality?.id ||
            generality.italian?.location ||
            generality.italian?.province
              ? {
                  nomeComune: generality.italian?.municipality?.description || undefined,
                  codiceIstat: generality.italian?.municipality?.id || undefined,
                  siglaProvinciaIstat:
                    generality?.italian?.province ||
                    generality.italian?.municipality?.province ||
                    undefined,
                  descrizioneLocalita: generality.italian?.location || undefined,
                }
              : undefined,
          localita:
            generality.foreign?.municipality?.id ||
            generality.foreign?.state?.id ||
            generality.foreign?.province
              ? {
                  descrizioneLocalita: generality.foreign?.municipality?.description || undefined,
                  descrizioneStato: generality.foreign?.state?.value || undefined,
                  codiceStato: generality.foreign?.state?.id || undefined,
                  provinciaContea:
                    generality.foreign?.province ||
                    generality.foreign?.state?.province ||
                    generality?.foreign?.municipality?.province ||
                    undefined,
                }
              : undefined,
        },
        soggettoAIRE: generality.aire || undefined,
        idSchedaSoggettoComune:
          generality.istatCode || generality.municipalityIdentifier
            ? {
                idSchedaSoggettoComuneIstat: generality.istatCode || undefined,
                idSchedaSoggetto: generality.municipalityIdentifier || undefined,
              }
            : undefined,
        idSchedaSoggettoANPR: generality.anprIdentifier || undefined,
        note: generality.note || undefined,
      }
    : undefined;
};

// const transformSubjectAttributes = (
//   attributes: AccordionSubjectAttributesVM | undefined
// ): SubjectAttributes | undefined => {
//   return attributes
//     ? {
//         senzaFissaDimora: attributes?.homeless ? 'S' : 'N',
//         soggettoCertificabile: attributes?.subject || '',
//       }
//     : undefined;
// };

// const transformBirthdayDocument = (
//   document: BirthdayDocument | undefined
// ): Document | undefined => {
//   return document
//     ? {
//         anno: document?.year || undefined,
//         comuneRegistrazione:
//           document?.municipality?.id ||
//           document?.location ||
//           document?.municipality?.description ||
//           document?.municipality?.province
//             ? {
//                 codiceIstat: document?.municipality?.id || undefined,
//                 descrizioneLocalita: document?.location || undefined,
//                 nomeComune: document?.municipality?.description || undefined,
//                 siglaProvinciaIstat: document?.municipality?.province || undefined,
//               }
//             : undefined,
//         dataFormazioneAtto: document?.documentDate?.toFormat('yyyy-MM-dd') || undefined,
//         numeroAtto: document?.documentNumber || undefined,
//         parte: document?.portion || undefined,
//         serie: document?.serie || undefined,
//         trascritto: document?.transcript ? 'S' : 'N',
//         ufficioMunicipio: document?.townHallOffice || undefined,
//         volume: document?.volume || undefined,
//       }
//     : undefined;
// };

export const transformCitizenship = (
  values: Array<CitizenshipVM> | undefined
): Array<Citizenship | undefined> | undefined => {
  return values && values?.length > 0
    ? values.map((citizen) => transformCitizen(citizen))
    : undefined;
};

const transformDocumentoRichiedente = (
  values: RegisterOfficeVM
): DocumentoRichiedente | undefined => {
  if (values.applicantIsAccountholder) {
    if (
      values.accountholderData?.identificationDocument?.documentNumber ||
      values.accountholderData?.identificationDocument?.issuedDate ||
      values.accountholderData?.identificationDocument?.municipality?.id ||
      values.accountholderData?.identificationDocument?.placeForeign
    ) {
      return {
        numeroDocumento:
          values.accountholderData?.identificationDocument?.documentNumber || undefined,
        dataRilascioDocumento: values.accountholderData?.identificationDocument?.issuedDate
          ? values.accountholderData?.identificationDocument?.issuedDate.toFormat('yyyy-MM-dd')
          : undefined,
        comuneRilascioDocumento: values.accountholderData?.identificationDocument?.municipality?.id
          ? Number.parseInt(
              values.accountholderData?.identificationDocument?.municipality?.id?.toString(),
              10
            )
          : undefined,
        luogoEsteroRilascioDocumento:
          values.accountholderData?.identificationDocument?.placeForeign || undefined,
        codCittadinanza: (values.accountholderData.citizenship || [])[0]?.code || undefined,
      };
    }

    return undefined;
  }

  if (
    values.applicantData?.identificationDocument?.documentNumber ||
    values.applicantData?.identificationDocument?.issuedDate ||
    values.applicantData?.identificationDocument?.municipality?.id ||
    values.applicantData?.identificationDocument?.placeForeign
  ) {
    return {
      numeroDocumento: values.applicantData?.identificationDocument?.documentNumber || undefined,
      dataRilascioDocumento: values.applicantData?.identificationDocument?.issuedDate
        ? values.applicantData?.identificationDocument?.issuedDate.toFormat('yyyy-MM-dd')
        : undefined,
      comuneRilascioDocumento: values.applicantData?.identificationDocument?.municipality?.id
        ? Number.parseInt(
            values.applicantData?.identificationDocument?.municipality?.id?.toString(),
            10
          )
        : undefined,
      luogoEsteroRilascioDocumento:
        values.applicantData?.identificationDocument?.placeForeign || undefined,
      codCittadinanza: (values.applicantData?.citizenship || [])[0]?.code || undefined,
    };
  }

  return undefined;
};

interface IdentificationDocument {
  comuneRilascio: {
    nomeComune?: string;
  };
  dataRilascio?: string;
  numero?: string;
}

interface DocumentoRichiedente {
  numeroDocumento?: string;
  dataRilascioDocumento?: string;
  comuneRilascioDocumento?: number;
  luogoEsteroRilascioDocumento?: string;
  codCittadinanza?: string;
}
interface RequestRegisterOffice {
  stepBozza?: number;
  key: {
    tipoRegistro?: string;
    codiceEnte?: string;
    idAnnoPratica?: number;
    progressivoPratica?: number;
  };
  //intestatarioDaMaschera: boolean;
  tipoIniziativa?: string;
  richiedente?: Generality;
  documentoRichiedente?: DocumentoRichiedente;
  richiedenteEqualsIntestatario?: boolean;
  intestatario?: {
    datiCancellazione?: DataDeletion;
    generalita?: Generality;
    attributiSoggetto?: SubjectAttributes;
    attoNascita?: Document;
    cittadinanza?: Array<Citizenship | undefined>;
    residenza?: Array<Residence>;
    maternita?: Parenthood;
    paternita?: Parenthood;
    matrimonio?: Marriage;
    unioneCivile?: CivilUnion;
    annullamentoMatrimonio?: VoidMarriage;
  };
  irreperibile?: boolean;
  minorePreadozione?: boolean;
  comune?: Municipality;
  comunePrecedente?: {
    codice?: string;
    codiceSipo?: string;
  };
  localita?: Place;
  cartaIdentita?: IdentificationDocument;
}

export const transformRequestRegisterOffice = (
  values: RegisterOfficeVM,
  stepBozza: number,
  praticaKey: PraticaVoVM
): RequestRegisterOffice => {
  let maternita: Parenthood | undefined, paternita: Parenthood | undefined;

  if (values.accountholderData?.mother) {
    maternita = {
      generalita: {
        nome: values.accountholderData?.mother?.name || '',
        cognome: values.accountholderData?.mother?.surname,
      },
    };
  } else if (values.accountholderData?.subjectData?.maternita) {
    maternita = values.accountholderData?.subjectData?.maternita;
  }

  if (values.accountholderData?.father) {
    paternita = {
      generalita: {
        nome: values.accountholderData?.father?.name || '',
        cognome: values.accountholderData?.father?.surname,
      },
    };
  } else if (values.accountholderData?.subjectData?.paternita) {
    paternita = values.accountholderData?.subjectData?.paternita;
  }

  let matrimonio: Marriage | undefined, unioneCivile: CivilUnion | undefined;

  if (values.accountholderData?.marriage) {
    matrimonio = {
      coniuge: {
        nome: values.accountholderData?.marriage?.name || '',
        cognome: values.accountholderData?.marriage?.surname,
      },
    };
  } else if (values.accountholderData?.subjectData?.matrimonio) {
    matrimonio = values.accountholderData?.subjectData?.matrimonio;
  }

  if (values.accountholderData?.civilUnion) {
    unioneCivile = {
      unitoCivilmente: {
        nome: values.accountholderData?.civilUnion?.name || '',
        cognome: values.accountholderData?.civilUnion?.surname,
      },
    };
  } else if (values.accountholderData?.subjectData?.paternita) {
    unioneCivile = values.accountholderData?.subjectData?.unioneCivile;
  }

  return {
    stepBozza:
      stepBozza > PracticeDraftBEStep.RegisterOffice
        ? stepBozza
        : PracticeDraftBEStep.RegisterOffice,
    key: {
      tipoRegistro: praticaKey.typeRegister || undefined,
      codiceEnte: praticaKey.codeEnte || undefined,
      idAnnoPratica: praticaKey.yearId ? Number.parseInt(praticaKey.yearId, 10) : undefined,
      progressivoPratica: praticaKey.progressive
        ? Number.parseInt(praticaKey.progressive, 10)
        : undefined,
    },
    // Se i dati dell'intestatario vengono da ANPR o DB = false, se vengono caricati dalla maschera = true
    // intestatarioDaMaschera: !values.accountholderData?.withSearch,
    richiedenteEqualsIntestatario: values.applicantIsAccountholder || false, // true se coincide con l'intestatrio
    richiedente: values.applicantIsAccountholder
      ? transformGenerality(values.accountholderData?.generality) // se sono uguali mando i dati dell'intestatrio
      : transformGenerality(values.applicantData?.generality),
    // documentoRichiedente
    documentoRichiedente: transformDocumentoRichiedente(values),
    intestatario: {
      datiCancellazione: values.accountholderData?.datiCancellazione || undefined,
      generalita: transformGenerality(values.accountholderData?.generality),
      attoNascita: values.accountholderData?.subjectData?.attoNascita,
      // attributiSoggetto: transformSubjectAttributes(
      //   values.accountholderData?.accordionSubjectAttributes
      // ),
      // attoNascita: transformBirthdayDocument(values.accountholderData?.birthdayDocument),
      cittadinanza: transformCitizenship(values.accountholderData?.citizenship),
      residenza:
        values?.accountholderData?.subjectData?.residenza &&
        values?.accountholderData?.subjectData?.residenza?.length > 0
          ? values?.accountholderData?.subjectData?.residenza
          : undefined,
      maternita,
      paternita,
      // Mettere matrimonio o unione civile, gli stessi della 3002 coniuge con dentro generalità
      unioneCivile,
      matrimonio,
      annullamentoMatrimonio: values.accountholderData?.subjectData?.annullamentoMatrimonio,
    },
    irreperibile: values.accountholderData?.residenceOrigin?.irreperibile,
    minorePreadozione: values.accountholderData?.residenceOrigin?.neverRegistered,
    comune: values.accountholderData?.residenceOrigin?.isForeign
      ? undefined
      : values.accountholderData?.residenceOrigin?.origin?.description ||
        values.accountholderData?.residenceOrigin?.origin?.id ||
        values.accountholderData?.residenceOrigin?.origin?.province
      ? {
          nomeComune: values.accountholderData?.residenceOrigin?.origin?.description,
          codiceIstat: values.accountholderData?.residenceOrigin?.origin?.id,
          siglaProvinciaIstat: values.accountholderData?.residenceOrigin?.origin?.province,
        }
      : undefined,
    localita: values.accountholderData?.residenceOrigin?.isForeign
      ? {
          descrizioneStato: values.accountholderData?.residenceOrigin?.originState?.value,
          codiceStato: values.accountholderData?.residenceOrigin?.originState?.id,
          provinciaContea: values.accountholderData?.residenceOrigin?.originState?.province,
          descrizioneLocalita:
            values.accountholderData?.residenceOrigin?.originMunicipalityForeign?.description,
        }
      : undefined,
    comunePrecedente:
      values.accountholderData?.residenceOrigin?.previousOriginCode ||
      values.accountholderData?.residenceOrigin?.previousOriginSipoCode
        ? {
            codice: values.accountholderData?.residenceOrigin?.previousOriginCode,
            codiceSipo: values.accountholderData?.residenceOrigin?.previousOriginSipoCode,
          }
        : undefined,
    // provenienza: {
    //   comune: {
    //     nomeComune: values.accountholderData?.residenceOrigin?.origin,
    //   },
    // },
    // cartaIdentita: {
    //   comuneRilascio: {
    //     nomeComune: values.applicantData?.identificationDocument?.issuedPlace || undefined,
    //   },
    //   numero: values.applicantData?.identificationDocument?.documentNumber || undefined,
    //   dataRilascio:
    //     values.applicantData?.identificationDocument?.issuedDate?.toFormat('yyy-MM-dd') ||
    //     undefined,
    // },
  };
};
